/**
 * Validation helpers for Liquid macros used as a dynamic media (icon/image) value.
 *
 * The field accepts a plain URL, a single macro, or a URL with an embedded macro. We only detect
 * whether a value contains a macro (to route it to the dynamic-macro source and render a "dynamic"
 * preview placeholder); we do not verify the macro is well-formed or that it resolves to an image.
 */

/** True if the value contains a Liquid macro anywhere (e.g. a URL with an embedded `{{…}}`). */
export function containsMacro(value: string | null | undefined): boolean {
    if (!value) return false
    return /\{\{|\{%/.test(value)
}
